export default "__VITE_ASSET__6dH9jyAc__"